export default function () {
	window.onkeydown = function (e) {
		if ((e.key == ' ' || e.code == 'Space') && e.target == document.body) {
			e.preventDefault();
		}
	};
}
